import { Box, Card, CardHeader, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, Tooltip } from "@mui/material";
import PerfectScrollbar from "react-perfect-scrollbar";
import _ from "lodash";
import useTransactions from "hooks/useTransactions";

const TransactionsComponent = () => {
  const { data, isValidating } = useTransactions({ id: "" });
  return (
    <Card sx={{ m: 5 }}>
      <CardHeader title={"TRANSACTIONS"} />
      <PerfectScrollbar>
        <Box sx={{ minWidth: 800 }}>
          {isValidating ? (
            <Box style={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress size="10rem" sx={{ m: 3 }} />
            </Box>
          ) : (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>SessionId</TableCell>
                  <TableCell>GameRoundId</TableCell>
                  <TableCell>Token</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell sortDirection="desc">
                    <Tooltip enterDelay={300} title="Sort">
                      <TableSortLabel active direction="desc">
                        Created
                      </TableSortLabel>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {_.isEmpty(data) == false &&
                  data?.items.map((transaction) => (
                    <TableRow hover key={transaction.id}>
                      <TableCell>{transaction.sessionId}</TableCell>
                      <TableCell>{transaction.gameRoundId}</TableCell>
                      <TableCell>{transaction.token}</TableCell>
                      <TableCell>{transaction.type}</TableCell>
                      <TableCell>{transaction.amount}</TableCell>
                      <TableCell>{transaction.created.toString()}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          )}
        </Box>
      </PerfectScrollbar>
    </Card>
  );
};

export default TransactionsComponent;
